export default __webpack_public_path__ + "static/media/dataafrica.96d472c9.png";